import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import DropdownMenu from '../../shared/dropdownMenu';

import {
  showBusinessModalForAdd,
} from './store/actions';

class BusinessMenu extends PureComponent {
  static propTypes = {
    showBusinessModalForAdd: PropTypes.func.isRequired,
  };

  showBusinessModalForAdd = () => {
    this.dropdown.hideDropDown();
    const { showBusinessModalForAdd } = this.props;
    showBusinessModalForAdd({});
  };

  render() {
    return (
      <DropdownMenu ref={dropdown => (this.dropdown = dropdown)} contentClassName="hamburger-menu">
        <button
          className="hamburger-action link-button"
          tabIndex="0"
          onClick={this.showBusinessModalForAdd}
        >
          Add Business Code
        </button>
      </DropdownMenu>
    );
  }
}

export default connect(
  null,
  {
    showBusinessModalForAdd,
  }
)(BusinessMenu);
